import React from 'react';
import { useSelector } from 'react-redux';

const About = () => {
  const language = useSelector((state) => state.language);

  return (
    <div className={`min-h-screen bg-gradient-to-br from-white via-blue-50 to-indigo-50 py-20 px-4`} dir={language === "ar" ? "rtl" : "ltr"}>
      <div className="container mx-auto max-w-4xl">
        <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
          {language === "ar" ? "حول RAQIB" : language === "fr" ? "À propos de RAQIB" : "About RAQIB"}
        </h1>
        
        <div className="bg-white rounded-xl shadow-lg p-8 space-y-6">
          <div>
            <h2 className="text-2xl font-bold text-teal-600 mb-4">
              {language === "ar" ? "مهمتنا" : language === "fr" ? "Notre Mission" : "Our Mission"}
            </h2>
            <p className="text-gray-700 leading-relaxed">
              {language === "ar" 
                ? "نحن نعتقد أن التكنولوجيا يجب أن تبسط الرعاية الصحية وليس تعقيدها. RAQIB مصمم لتمكين مقدمي الرعاية الصحية بأدوات ذكية لإدارة المرضى بكفاءة وتحسين نتائج الرعاية."
                : language === "fr"
                ? "Nous croyons que la technologie doit simplifier les soins de santé et non les compliquer. RAQIB est conçu pour donner aux prestataires de soins de santé les outils intelligents pour gérer efficacement les patients et améliorer les résultats des soins."
                : "We believe that technology should simplify healthcare, not complicate it. RAQIB is designed to empower healthcare providers with intelligent tools to manage patients efficiently and improve care outcomes."}
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-bold text-teal-600 mb-4">
              {language === "ar" ? "قيمنا" : language === "fr" ? "Nos Valeurs" : "Our Values"}
            </h2>
            <ul className="space-y-3 text-gray-700">
              <li className="flex items-start">
                <span className="text-teal-500 mr-3 font-bold">✓</span>
                <span>
                  {language === "ar" 
                    ? "الابتكار: نحن نسعى باستمرار لتحسين وتطوير حلولنا"
                    : language === "fr"
                    ? "Innovation: nous cherchons continuellement à améliorer nos solutions"
                    : "Innovation: We continuously strive to improve and innovate"}
                </span>
              </li>
              <li className="flex items-start">
                <span className="text-teal-500 mr-3 font-bold">✓</span>
                <span>
                  {language === "ar" 
                    ? "الأمان: نحن نلتزم بأعلى معايير الأمان وحماية البيانات"
                    : language === "fr"
                    ? "Sécurité: nous nous engageons aux plus hauts standards de sécurité"
                    : "Security: We are committed to the highest standards of data protection"}
                </span>
              </li>
              <li className="flex items-start">
                <span className="text-teal-500 mr-3 font-bold">✓</span>
                <span>
                  {language === "ar" 
                    ? "دعم المستخدم: فريقنا متواجد دائماً لمساعدتك"
                    : language === "fr"
                    ? "Support utilisateur: notre équipe est toujours disponible"
                    : "User Support: Our team is always available to assist you"}
                </span>
              </li>
            </ul>
          </div>

          <div>
            <h2 className="text-2xl font-bold text-teal-600 mb-4">
              {language === "ar" ? "تاريخنا" : language === "fr" ? "Notre Histoire" : "Our Story"}
            </h2>
            <p className="text-gray-700 leading-relaxed">
              {language === "ar" 
                ? "تأسست RAQIB برؤية واضحة لتحويل الرعاية الصحية من خلال التكنولوجيا الذكية. يجمع فريقنا بين الخبرة الطبية والخبرة التقنية لإنشاء حل شامل يلبي احتياجات مقدمي الرعاية الصحية الحقيقية."
                : language === "fr"
                ? "RAQIB a été fondée avec une vision claire de transformer les soins de santé par la technologie intelligente. Notre équipe combine l'expertise médicale et technique pour créer une solution complète."
                : "RAQIB was founded with a clear vision to transform healthcare through intelligent technology. Our team combines medical expertise and technical knowledge to create a comprehensive solution."}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
